export default __webpack_public_path__ + "static/services-3-fa4e2d133f0799daf2020e1a7abfb3eb.jpg";